import { FaBars } from 'react-icons/fa';

const HamburgerButton = ({ toggleNav, ariaLabel, className = '' }) => (
  <button
    className={`hamburger-btn te-icon-btn ${className}`}
    onClick={toggleNav}
    data-testid="navbar-hamburger-button"
    aria-label={ariaLabel}
    type="button"
  >
    <FaBars />
  </button>
);

export default HamburgerButton;
